import React from 'react';
import Header from '../../components/Layout/Header';
import './Department.css';

const Marketing: React.FC = () => {
  return (
    <div className="department-page">
      <Header />
      <div className="department-container">
        <div className="department-header">
          <h1>Marketing Department</h1>
          <p className="department-description">
            Welcome to the Marketing Department page. Here you can find marketing campaigns, 
            brand information, and promotional resources.
          </p>
        </div>
        <div className="department-content">
          <div className="department-card">
            <h3>About Marketing Department</h3>
            <p>
              The Marketing Department is responsible for brand management, marketing campaigns, 
              market research, advertising, and promoting the company's products and services.
            </p>
          </div>
          <div className="department-card">
            <h3>Key Functions</h3>
            <ul>
              <li>Brand Management</li>
              <li>Marketing Campaigns</li>
              <li>Market Research</li>
              <li>Advertising and Promotion</li>
              <li>Digital Marketing</li>
              <li>Public Relations</li>
            </ul>
          </div>
          <div className="department-card">
            <h3>Contact Information</h3>
            <p>For marketing-related inquiries, please contact the Marketing Department.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Marketing;

